let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c7iYX")).then(() => parcelRequire('cJWAz'));